module.exports = __webpack_public_path__ + "img/minus-solid.e3c44a30.svg";